<template>
  <ul class="list-group">
    <li
      @click="onDetail(t)"
      class="list-group-item list-group-item-action d-flex align-items-center bd-0"
      v-for="(t, i) in tasks"
      :key="i"
      role="button"
    >
      <div class="d-flex">
        <div class="avatar">
          <span :class="`avatar-initial rounded-circle ${getLessonIconBg(t)}`">
            <feather
              v-if="t.im != null && t.im.isDone"
              :type="getLessonIcon(t)"
              class="tx-white"
              style="margin-top: -4px; width: 19px; height: 19px;"
            ></feather>
            <feather
              v-else
              :type="getLessonIcon(t)"
              class="tx-inverse tx-color-02"
              style="margin-top: -4px; width: 19px; height: 19px;"
            ></feather>
          </span>
        </div>
        <div class="pd-l-10">
          <h6 class="tx-14 tx-semibold mg-b-5">{{ t.task }}</h6>
          <div
            class="d-flex align-items-center wd-100p"
            v-if="t.percent != null && t.percent.itemCount > 0"
          >
            <div class="progress ht-15 wd-100">
              <div
                role="progressbar"
                class="progress-bar bg-secondary"
                :style="{ width: t.percent.percent + '%' }"
              >
                <span class="tx-9">{{ t.percent.percent }}%</span>
              </div>
            </div>
            <div class="tx-11 mg-l-10">
              {{ t.percent.completedItemCount }}/{{ t.percent.itemCount }}
            </div>
          </div>
          <!-- <span class="d-block tx-11 text-muted">мин</span> -->
        </div>
      </div>
      <div class="mg-l-auto d-flex  align-items-center justify-content-end">
        <button
          v-if="t.resume"
          class="btn btn-xs btn-outline-light btn-uppercase d-flex"
        >
          <span class="mg-r-5">үзэх</span>
          <feather type="arrow-right" class="" :size="13"></feather>
        </button>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getLessonIcon(t) {
      let rv = "";
      if (t.im != null && t.im.isDone) {
        rv = "check-square";
      } else if (t.i == 1 && t.im == null) {
        rv = "lock";
      } else {
        return "square";
      }
      return rv;
    },
    getLessonIconBg(t) {
      let rv = "";
      if (t.im != null && t.im.isDone) {
        rv = "bg-success bd bd-success";
      } else if (t.i == 1 && t.im == null) {
        rv = "bg-danger";
      } else {
        return "bg-transparent bd bd-gray-900";
      }
      return rv;
    },
    onDetail(t) {
      if (this.$route.params.bot == 114) {
        this.$emit("on-detail", t);
      } else {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: t.id,
            cid: this.$route.params.id,
            bid: 0,
            iid: 0,
            bot: 0
          }
        });
      }
    }
  }
};
</script>

<style></style>
